const menuRo = {
    "add_to_cart": "Adaugă in coş",
    "add_to_order": "Adăugați la comandă",
    "already_in_cart": "Deja în coșul dvs.",
    "update_order_item": "Actualizați comanda",
    "delete_order_item": "Eliminați elementul",
    "available_categories": "Categorii de meniu",
    "search_menu_placeholder": "Căutare în meniu",
    "guides": {
        "scan_qr": "Scanează codul QR de pe masă cu telefonul tău",
        "order": "Comandați articolele selectate de pe telefon",
        "pay": "Plătește separat sau toate odată de pe telefon",
        "accept": "Continua"
    },
    "index_image": "Imagine index",
    "menu_saved": "Meniul a fost salvat",
    "new_category": "Categorie nouă",
    "menu_editor": "Meniul editorului",
    "new_item": "Articol nou",
    "menu": "Meniu",
    "allergens": "Alergeni",
    "generate_qr": "Generați cod QR",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Crustacee",
        "eggs": "Ouă",
        "fish": "Peşte",
        "peanuts": "Arahide",
        "soybeans": "Soia",
        "milk": "Lapte",
        "nuts": "Nuci",
        "celery": "Țelină",
        "mustard": "Muştar",
        "sesame": "Susan",
        "sulphur_dioxide": "Dioxid de sulf",
        "lupin": "Lupin",
        "molluscs": "Moluște",
        "vegan": "Vegan"
    },
    "add_allergen": "Adăugați alergen",
    "auto_translate": "Traducerea meniului",
    "no_category_name": "Niciun nume de categorie specificat în limba curentă",
    "no_item_name": "Niciun nume de element specificat în limba curentă",
    "category_and_items_language": "Limba categoriei și a articolelor",
    "auto_translate_title": "Traducerea automată a meniurilor poate fi aplicată doar categoriilor și elementelor care au fost deja salvate. Se recomandă completarea limbii inițiale.",
    "auto_translate_description": "Această funcție folosește Google Translate. Traducerile nu sunt întotdeauna corecte, așa că merită să le verificați.",
    "translate_from": "Traduceți din",
    "translate_to": "Către aceste limbi",
    "auto_translate_error_invalid_languages": "Limbi nevalide selectate pentru traducere",
    "auto_translate_success": "Meniul a fost tradus cu succes",
    "auto_translate_error_permission": "Nu aveți permisiunea de a traduce meniul.",
    "auto_translate_error_generic": "A apărut o eroare necunoscută în timpul traducerii",
    "auto_translate_feature_not_available": "Traducerea automată a meniurilor este disponibilă doar cu un abonament PRO.",
    "change_subscription_plan": "Schimbați planul de abonament",
    "menu_headers": "Anteturi și subsoluri de meniu",
    "menu_header_editor_title": "Anteturile și subsolurile de meniu sunt textele care apar în partea de sus și de jos a meniului online și pe care le puteți specifica în mod liber.",
    "menu_header_feature_not_available": "Editarea antetului și a subsolului meniului este disponibilă numai cu un abonament PRO.",
    "menu_header": "Antet de meniu",
    "menu_header_placeholder": "Scrieți un scurt mesaj de bun venit sau evidențiați o ofertă actuală",
    "menu_footer": "Subsol meniu",
    "menu_footer_placeholder": "Puteți introduce informații despre taxele de serviciu, alergeni sau alte informații importante",
    "menu_header_save_success": "Antetul și subsolul meniului au fost salvate cu succes",
    "menu_header_save_error": "A apărut o eroare la salvarea antetului și a subsolului meniului",
    "menu_header_permission_error": "Nu aveți permisiunea de a edita antetul și subsolul meniului.",
    "menu_header_generic_error": "A apărut o eroare necunoscută la încărcarea antetului și a subsolului meniului",
    "menu_import": "Importul meniului",
    "import_success": "Ultima importare a fost finalizată cu succes",
    "import_failed": "Ultima importare a eșuat din cauza unui export de pe server",
    "attached_document": "Document atașat",
    "allowed_file_types": "Tipuri de fișiere permise: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Limba documentului",
    "import_options_pro_helpertext": "Opțiunile „Dezactivare” și „Adăugare” sunt disponibile numai cu un abonament PRO.",
    "import_option_helpertexts": {
        "replace": "Categoriile și elementele actuale din meniu vor fi șterse și înlocuite cu meniul nou generat.",
        "deactivate": "Categoriile și elementele actuale din meniu vor fi dezactivate, iar meniul nou generat va fi adăugat.",
        "add": "Meniul curent va rămâne, iar noile elemente de meniu vor fi adăugate după meniul curent."
    },
    "import_type": "Tipul de import",
    "import_options": {
        "replace": "Înlocui",
        "deactivate": "Dezactivare",
        "add": "Adăuga"
    },
    "menu_import_tooltip": "Încărcați un fișier care conține meniul restaurantului dvs. sau furnizați un link către un site web care conține meniul. În ambele cazuri, asigurați-vă că meniul este disponibil textual în document, deoarece nu putem procesa imagini. După începerea importului, inteligența noastră artificială va procesa automat fișierul și va crea noul meniu în limba selectată. Dacă doriți să traduceți ulterior articolele în mai multe limbi, utilizați funcția „Traducere meniu”! Procesul de import durează 5-10 minute.",
    "menu_import_replace_warning": "Metoda de import selectată în prezent va șterge meniul curent și îl va înlocui cu noul meniu. Asigurați-vă că fișierul încărcat are formatul și conținutul corecte, deoarece operațiunea este ireversibilă! Dacă nu doriți să ștergeți meniul curent, vă rugăm să alegeți o altă metodă de import.",
    "start_import": "Import",
    "file_or_url_required": "Selectați un fișier sau furnizați adresa URL a unui site web",
    "file_and_url_error": "Puteți furniza fie un fișier, fie o adresă URL, nu ambele.",
    "import_site_url": "URL-ul site-ului web",
    "import_in_progress": "Import în curs",
    "import_duration": "Acest lucru poate dura câteva minute",
    "listing_manager_info": {
        "summary": "Cu Mozrest, poți gestiona cu ușurință anunțurile și recenziile tale de pe o singură platformă. Economisește timp, îmbunătățește-ți reputația online și crește eficiența operațională.",
        "bullet_1": "Actualizați-vă instantaneu anunțurile pe Tripadvisor, Apple Maps, Google, Facebook, Quandoo și Bing cu un singur clic.",
        "bullet_2": "Primește notificări în timp real atunci când orele și disponibilitatea nu corespund, prevenind dezamăgirea oaspeților și recenziile negative.",
        "bullet_3": "Verificați rapid dacă anunțul este complet pentru a vă asigura că toate detaliile importante - cum ar fi fotografiile, meniurile și programul - sunt corecte și actualizate.",
        "setup_button": "Configurați Mozrest",
        "pro_warning": "Această funcție necesită un abonament PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Listare",
        "ListingAnalytics": "Analiza listărilor",
        "ReviewsPage": "Recenzii",
        "ReviewAnalytics": "Analize de recenzii",
        "ReplyTemplates": "Șabloane de răspuns",
        "Notifications": "Notificări"
    },
    "review_manager_set_title": "Configurați managerul de recenzii",
    "review_manager_set_description": "Vă rugăm să furnizați câteva informații despre afacerea dvs. pentru a putea crea setările de bază.",
    "confirm_settings": "Confirmați setările"
};

export default menuRo;
